import React, { useMemo, useState } from "react";

export default function GoldFAQSection({
  faqs = [],
  subtitle = "Find quick answers to common questions about selling gold with G1 Gold.",
}) {
  const [showAllFaqs, setShowAllFaqs] = useState(false);
  const [openFaqIndex, setOpenFaqIndex] = useState(null);

  const visibleFaqs = useMemo(() => {
    return showAllFaqs ? faqs : faqs.slice(0, 5);
  }, [faqs, showAllFaqs]);

  if (!faqs || faqs.length === 0) return null;

  return (
    <section className="relative overflow-hidden bg-[#fffaf0] py-16 lg:py-20">
      <div className="relative mx-auto max-w-[1450px] px-5 sm:px-6 lg:px-10">
        <div className="mx-auto max-w-5xl text-center">
          <p className="text-[12px] font-bold uppercase tracking-[0.34em] text-[#b98512]">
            FAQ
          </p>

          <h2 className="mt-5 font-serif text-[36px] font-bold leading-tight text-[#111827] sm:text-[48px] lg:text-[62px]">
            Frequently Asked <span className="text-[#b98512]">Questions</span>
          </h2>

          <p className="mx-auto mt-6 max-w-3xl text-[17px] font-medium leading-8 text-[#334155] sm:text-[18px]">
            {subtitle}
          </p>
        </div>

        <div className="mx-auto mt-12 max-w-[1050px] space-y-5">
          {visibleFaqs.map((faq, index) => {
            const isOpen = openFaqIndex === index;

            return (
              <div
                key={index}
                className="overflow-hidden rounded-[18px] border border-[#ead8a8] bg-white shadow-[0_14px_35px_rgba(20,33,61,0.06)]"
              >
                <button
                  type="button"
                  onClick={() => setOpenFaqIndex(isOpen ? null : index)}
                  className="flex w-full items-center justify-between gap-5 px-5 py-5 text-left sm:px-7 sm:py-6 lg:px-8"
                >
                  <h3 className="text-[17px] font-extrabold leading-snug text-[#06152f] sm:text-[19px] lg:text-[20px]">
                    {faq.question}
                  </h3>

                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-[#d7a51f] text-[26px] font-light text-[#b98512]">
                    {isOpen ? "−" : "+"}
                  </span>
                </button>

                {isOpen && (
                  <div className="border-t border-[#ead8a8] px-5 py-5 sm:px-7 lg:px-8">
                    <p
                      className="text-[15px] font-medium leading-7 text-[#334155] sm:text-[16px]"
                      dangerouslySetInnerHTML={{
                        __html: faq.answer || "",
                      }}
                    />
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {faqs.length > 5 && (
          <div className="mt-9 text-center">
            <button
              type="button"
              onClick={() => setShowAllFaqs((prev) => !prev)}
              className="rounded-full bg-gradient-to-r from-[#c88908] to-[#dfaa1c] px-8 py-3.5 text-[15px] font-bold text-white shadow-[0_14px_30px_rgba(198,146,24,0.25)]"
            >
              {showAllFaqs ? "Show Less" : "Show More"}
            </button>
          </div>
        )}
      </div>
    </section>
  );
}